import { useUserContext } from 'contexts/UserContext';
import { ManagerDashboard } from 'views/Dashboard/ManagerDashboard';
import { UserCalendar } from '../UserCalendar';

export const Dashboard = () => {
  const { isManager } = useUserContext();

  return <>{isManager ? <ManagerDashboard /> : <UserCalendar />}</>;
};
